import React, { useState, useEffect } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
// import axios from 'axios';
import { ServerPath } from '../../Constant';
import { _axios } from '../../utils/axios';

const LogsReportModal = ({ show, onHide, notificationId }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Pagination States
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    // Fetch data when show, notificationId, page, or perPage changes
    useEffect(() => {
        if (show && notificationId) {
            fetchLogs(currentPage, perPage);
        }
    }, [show, notificationId, currentPage, perPage]);

    const formatDates = (items) => {
        return items.map(item => {
            const formatDate = (dateString) => {
                if (!dateString) return "-";
                try {
                    const options = {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        // second: "2-digit", // uncomment if you want seconds also
                        hour12: true, // set false if you want 24-hour format
                    };
                    return new Date(dateString).toLocaleString(undefined, options);
                } catch (error) {
                    return "Invalid Date";
                }
            };

            return {
                ...item,
                created_at: formatDate(item.created_at),
                updated_at: formatDate(item.updated_at), // Fixed from sent_at to match your SQL
            };
        });
    };

    const fetchLogs = async (page, size) => {
        setLoading(true);
        try {
            const response = await _axios.get(
                `${ServerPath}/admin-notification/logs/${notificationId}?page=${page}&pageSize=${size}`
            );

            // 1. Format the data for the table
            const formattedData = formatDates(response.data.data);
            setData(formattedData);

            // 2. Set the total rows from the backend response
            // This makes the "Next/Previous" buttons work correctly
            setTotalRows(response.data.total);

        } catch (error) {
            console.error("Error fetching notification logs:", error);
        } finally {
            setLoading(false);
        }
    };

    // Handle page change
    const handlePageChange = page => {
        setCurrentPage(page);
    };

    // Handle rows per page change
    const handlePerRowsChange = async (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };

    const columns = [
        { name: 'User ID', selector: row => row.user_id, sortable: true, grow: 1.5 },
        { name: 'Channel', selector: row => row.channel, sortable: true, center: true },
        { name: 'Push Enabled', selector: row => row.push_enabled === 1 ? 'Yes' : 'No', center: true },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            cell: row => (
                <span className={`badge ${getStatusColor(row.status)}`}>
                    {row.status}
                </span>
            )
        },
        { name: 'Failure Reason', selector: row => row.failure_reason || '-', wrap: true, grow: 2 },
        { 
        name: 'Timestamp', 
        selector: row => row.updated_at, 
        sortable: true,
        minWidth: '250px', // Ensures the full date/time string fits
        style: { fontWeight: '500' } // Optional: makes it slightly more readable
    },
    ];

    const getStatusColor = (status) => {
        switch (status) {
            case 'Sent': case 'Delivered': return 'bg-success';
            case 'Failed': return 'bg-danger';
            case 'Skipped': return 'bg-warning text-dark';
            case 'Pending': return 'bg-secondary';
            default: return 'bg-light text-dark';
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontWeight: '600' }}>
                    Delivery Logs: {notificationId}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <DataTable
                    columns={columns}
                    data={data}
                    progressPending={loading}
                    progressComponent={<Spinner animation="border" variant="primary" />}

                    // Server-side pagination props
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}

                    responsive
                    highlightOnHover
                // subHeader
                // subHeaderComponent={
                //     <div className="text-muted small">
                //         Showing page {currentPage} of logs.
                //     </div>
                // }
                />
            </Modal.Body>
        </Modal>
    );
};

export default LogsReportModal;